import { memo } from 'react';
import { Box, Card, Tag, Text } from '@zillow/constellation-10';
import type { YourRentalPaymentCardDto } from '@zg-rentals/ts-your-rental-api-client';
import { TAG_APPEARANCE_MAP } from '../../constants';
import CtaButton from '../shared/CtaButton';

const PaymentCard = memo(({ paymentCard }: { paymentCard: YourRentalPaymentCardDto }) => {
  const { amount, cardTitle, cta, dueDate, dueText, rentReportingStatusTag } = paymentCard;

  return (
    <Card
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: 'loose',
        gap: { base: 'tighter', lg: 'loose' },
      }}
    >
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'stretch',
          gap: { base: 'tighter', lg: 'loose' },
        }}
      >
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: { base: 'tighter', lg: 'loose' },
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            '@media (min-width: 385px) ': {
              flexDirection: 'row',
            },
            '@media (min-width: 768px) and (max-width: 795px)': {
              flexDirection: 'column',
            },
            '@media (min-width: 1280px) and (max-width: 1350px)': {
              flexDirection: 'column',
            },
          }}
        >
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'tighter',
            }}
          >
            <Text textStyle="body-sm-bold" data-testid="RentReporting-PaymentCardTitle">
              {cardTitle}
            </Text>
            <Text textStyle="heading-md" data-testid="RentReporting-PaymentCardAmount">
              {amount}
            </Text>
          </Box>
          {rentReportingStatusTag && (
            <Tag
              size="sm"
              tone={TAG_APPEARANCE_MAP[rentReportingStatusTag.tagAppearance]}
              data-testid="RentReporting-EnrolledTag"
            >
              {rentReportingStatusTag.tagText}
            </Tag>
          )}
        </Box>
        <Box
          css={{
            display: 'flex',
            gap: 'tightest',
          }}
        >
          <Text data-testid="RentReporting-PaymentCardDueText">{dueText}</Text>
          <Text textStyle="body-bold" data-testid="RentReporting-PaymentCardDueDate">
            {dueDate}
          </Text>
        </Box>
      </Box>
      <CtaButton cta={cta} dataTestId={`RentReporting-PaymentCardCta`} />
    </Card>
  );
});

PaymentCard.displayName = 'PaymentCard';
export default PaymentCard;
